// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610021508/js/" + chunkId + "." + {"44":"902b96c3","225":"786868a4","481":"f7bcf2c2","486":"ebab88d0","770":"a4e5b937"}[chunkId] + ".0.8941589749329987.chunk.js";
};